import * as angular from 'angular';
import * as OverviewContactMeCard from './overview-contact-me-card';
import * as OverviewAdditionalInformationSection from './overview-additional-information-section';
import * as OverviewBasicInformationSection from './overview-basic-information-section';
import * as OverviewDiscountsSection from './overview-discounts-section';
import * as OverviewPageHeaderComponent from './overview-page-header';
import * as OverviewMyDocumentsSection from './overview-my-documents-section';
import * as OverviewPolicyType from './overview-policy-type';

const module = angular.module('overview-page-components', [
    OverviewContactMeCard.module.name,
    OverviewBasicInformationSection.module.name,
    OverviewAdditionalInformationSection.module.name,
    OverviewDiscountsSection.module.name,
    OverviewPageHeaderComponent.module.name,
    OverviewMyDocumentsSection.module.name,
    OverviewPolicyType.module.name
]);

export { module };
